<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>Add Society</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7">
            <v-form>
              <v-radio-group v-model="formData.societyType" row>
                <v-radio
                  v-for="type in societyTypes"
                  :key="type.value"
                  :label="`${type.value}`"
                  :value="type.id"
                  class="float-left"
                ></v-radio>
              </v-radio-group>
              <v-row>
                <v-col cols="12">
                   <v-checkbox
                    v-model="formData.has_multiple_building"
                    :true-value="1"
                    :false-value="0"
                    label="Has Multiple Building"
                    dense
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="3" v-if="formData.societyType == 1 || formData.societyType == 3">
                  <v-text-field
                    v-model="formData.noOfHouse"
                    outlined
                    dense
                    label="No of house"
                    name="noOfHouse"
                    type="number"
                    v-validate="'required'"
                    :error="
                      errors.first('noOfHouse') != null ||
                      serverSideErrors.noOfHouse != null
                    "
                    :error-messages="
                      errors.first('noOfHouse') || serverSideErrors.noOfHouse
                    "
                  />
                </v-col>
                <v-col
                  :cols="formData.societyType == 3 ? 6 : (formData.societyType == 1 ? 6 : 12)"
                  :sm="formData.societyType == 3 ? 6 : (formData.societyType == 1 ? 6 : 12)"
                  :md="formData.societyType == 3 ? 3 : (formData.societyType == 1 ? 3 : 6)"
                  v-if="formData.societyType == 2 || formData.societyType == 3"
                >
                  <v-text-field
                    v-model="formData.noOfShop"
                    outlined
                    dense
                    label="No of shops"
                    name="noOfShop"
                    type="number"
                    v-validate="'required'"
                    :error="
                      errors.first('noOfShop') != null ||
                      serverSideErrors.noOfShop != null
                    "
                    :error-messages="
                      errors.first('noOfShop') || serverSideErrors.noOfShop
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="formData.name"
                    outlined
                    dense
                    label="Society Name"
                    name="name"
                    v-validate="'required'"
                    :error="
                      errors.first('name') != null ||
                      serverSideErrors.name != null
                    "
                    :error-messages="
                      errors.first('name') || serverSideErrors.name
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="formData.address"
                    outlined
                    dense
                    label="Society Address"
                    name="address"
                    v-validate="'required'"
                    :error="
                      errors.first('address') != null ||
                      serverSideErrors.address != null
                    "
                    :error-messages="
                      errors.first('address') || serverSideErrors.address
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="3">
                  <v-text-field
                    v-model="formData.city"
                    outlined
                    dense
                    label="City"
                    name="city"
                    v-validate="'required'"
                    :error="
                      errors.first('city') != null ||
                      serverSideErrors.city != null
                    "
                    :error-messages="
                      errors.first('city') || serverSideErrors.city
                    "
                  />
                </v-col>
                <v-col cols="6" sm="6" md="3">
                  <v-text-field
                    v-model="formData.pincode"
                    outlined
                    dense
                    label="Pincode"
                    name="pincode"
                    v-validate="'required'"
                    :error="
                      errors.first('pincode') != null ||
                      serverSideErrors.pincode != null
                    "
                    :error-messages="
                      errors.first('pincode') || serverSideErrors.pincode
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="formData.state"
                    outlined
                    dense
                    label="State"
                    name="state"
                    v-validate="'required'"
                    :error="
                      errors.first('state') != null ||
                      serverSideErrors.state != null
                    "
                    :error-messages="
                      errors.first('state') || serverSideErrors.state
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="formData.country"
                    :items="countries"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    label="Country"
                    name="country"
                    v-validate="'required'"
                    :error="
                      errors.first('country') != null ||
                      serverSideErrors.country != null
                    "
                    :error-messages="
                      errors.first('country') || serverSideErrors.country
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-file-input
                    v-model="formData.logo"
                    outlined
                    dense
                    name="logo"
                    label="Logo"
                    v-validate="'required'"
                    :error="
                      errors.first('logo') != null ||
                      serverSideErrors.logo != null
                    "
                    :error-messages="
                      errors.first('logo') || serverSideErrors.logo
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="formData.contactPersonName"
                    outlined
                    dense
                    label="Contact Person Name"
                    name="contactPersonName"
                    v-validate="'required'"
                    :error="
                      errors.first('contactPersonName') != null ||
                      serverSideErrors.contactPersonName != null
                    "
                    :error-messages="
                      errors.first('contactPersonName') ||
                      serverSideErrors.contactPersonName
                    "
                  />
                </v-col>
              </v-row>
              <v-row>


                <v-col cols="12" sm="12" md="6" class="d-flex">
                  <country-code-select
                    v-model="selectedCountryCode"
                    @onSelect="onSelect" 
                    class="custom-country-code-select"

                  ></country-code-select>
                  <v-text-field
                    v-model="formData.contactPersonNumber"
                    outlined
                    dense
                    label="Contact Person Number"
                    name="Contact Person Number"
                    v-validate="'required'"
                    :error="
                      errors.first('Contact Person Number') != null ||
                      serverSideErrors.contactPersonNumber != null
                    "
                    :error-messages="
                      errors.first('Contact Person Number') ||
                      serverSideErrors.contactPersonNumber
                    "
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="formData.contactPersonEmail"
                    type="email"
                    outlined
                    dense
                    label="Contact Person Email"
                    name="Contact Person Email"
                    v-validate="'required|email'"
                    :error="
                      errors.first('Contact Person Email') != null ||
                      serverSideErrors.contactPersonEmail != null
                    "
                    :error-messages="
                      errors.first('Contact Person Email') ||
                      serverSideErrors.contactPersonEmail
                    "
                  />
                </v-col>
              </v-row>

            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveSociety"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      selectedCountryCode: "",
      loading: false,
      serverSideErrors: {},
      profile_pic: {},
      formData: {
        societyType: 1,
        has_multiple_building: 0,
        noOfHouse: 0,
        noOfShop: 0,
        name: null,
        address: null,
        country: null,
        state: null,
        city: null,
        contactPersonName: null,
        contactPersonNumber: null,
        contactPersonEmail: null,
        logo: null,
        pincode: null,
        country_code: "",
        countryIso: "",
      },
      countries: [],
      societyTypes: [
        {
          id: 1,
          value: "Resedential",
        },
        {
          id: 2,
          value: "Commercial",
        },
        {
          id: 3,
          value: "Resedential & Commercial",
        },
      ],
    };
  },
  methods: {
    onSelect(event) {
      this.formData.country_code = '+' + event.dialCode
      this.formData.countryIso = event.iso2
    },
    getCountries() {
      let _self = this;
      _self.$axios.get("/society/countries").then((response) => {
        if (response.data.status) {
          _self.countries = response.data.data;
        }
      });
    },
    
    // },
    ...mapMutations("alert", ["setAlert"]),
    resetForm() {
      this.$validator.reset();
      (this.formData.societyType = 1),
        (this.formData.has_multiple_building = 0),
        (this.formData.noOfHouse = 0),
        (this.formData.noOfShop = 0),
        (this.formData.name = null),
        (this.formData.address = null),
        (this.formData.country = null),
        (this.formData.state = null),
        (this.formData.city = null),
        (this.formData.contactPersonName = null),
        (this.formData.contactPersonNumber = null),
        (this.formData.contactPersonEmail = null),
      this.formData.pincode = null;
    },
    saveSociety() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          for (const [key, value] of Object.entries(this.formData)) {
            formData.append(key, value);
          }

          _self.$axios
            .post("/superadmin/society", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.resetForm();

                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
                localStorage.removeItem("countryCode");
                _self.$router.push({ path: "/superadmin/society/list" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },



  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getCountries();
  },
};
</script>

<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
.custom-country-code-select {
  width: 59px;
    height: 40px;
    margin-top: 10px
}
</style>
